import { markRead, markStar, moveFolder, delMail } from './mailListService'
import Vue from 'vue'
let vm = new Vue()
function mailsOperate (obj) {
    if ((obj.ids.constructor === Array && !obj.ids.length) || !obj.ids) {
        vm.$toast({
            message: '请选择邮件',
            theme: 'warning'
        })
        return
    }
    let res
    switch (obj.op) {
    case 'del':
        vm.$confirm({
            title: '彻底清除',
            message: '彻底删除的邮件将无法恢复，确定彻底删除邮件吗？',
            show: true,
            onSure: () => {
                res = delMail({
                    ids: obj.ids,
                    folderId: obj.folderId === undefined ? -10 : obj.folderId,
                    spamType: (obj.spamType || 0)
                })
                obj.callback(obj, res)
            }
        })
        break
    case 'markRead':
        res = markRead({ids: obj.ids, read: obj.read})
        break
    case 'markStar':
        res = markStar({ids: obj.ids, star: obj.star})
        break
    case 'move':
        res = moveFolder({
            ids: obj.ids,
            from: obj.folderId === undefined ? -10 : obj.folderId,
            to: obj.to
            // 搜索页面删除from传 -10
        })
        break
    }
    res && obj.callback(obj, res)
}
function showMoveById (folderId) {
    if (this.folderId) {
        return folderId === this.folderId
    }
    return false
}
function markStarOrNot (item, cb) {
    let res = markStar({ids: item.id, star: +!item.star})
    cb && cb({ op: 'markStar', ids: item.id }, res)
}
export {
    mailsOperate,
    showMoveById,
    markStarOrNot
}



// WEBPACK FOOTER //
// ./src/service/mailopService.js